<div class="content">
  <div class="tools">
    <mat-form-field class="search-bar" appearance="outline">
      <button class="search-icon" (click)="search($event)"  matPrefix mat-button><mat-icon>search</mat-icon></button>
      <input matInput (keyup)="checkSearchValue($event)"  (keydown.enter)="search($event)" placeholder="Search for endpoints" (input)="filter = $event.target.value" [value]="filter">
      <span matSuffix > </span>
      <button class="clear-button" mat-button mat-icon-button matSuffix (click)="clearSearchField()">
        <mat-icon>close</mat-icon>
     </button>
    </mat-form-field>
    <mat-paginator [pageSizeOptions]="getPageSizeOptions()"
      showFirstLastButtons 
      aria-label="Select page of endpoints"
      (page)="pageEndpoints($event)"
      [length]="getNumberOfEndpoints()"
      [pageIndex]="getPageNumber()"
      >
    </mat-paginator>
  </div>
  <div class="group" *ngFor="let endpoint of endpoints">
    <div class="group-content">
      <div class="group-avatar"[style.background-color]="getColorFromName(endpoint.registrationId)">{{endpoint.registrationId.substring(0,1)}}</div>
      <div class="group-text">
        <div class="group-name">{{endpoint.registrationId}}</div>
        <div class="group-desc">{{endpoint.organizationName}} / {{endpoint.endpointType}} /{{endpoint.clientAuthType}} / {{endpoint.apiLevel}} </div>
      </div>
    </div>
    <div class="action-buttons">
      <button  (click)="onEdit(endpoint)" mat-icon-button >
        <mat-icon>edit_outline</mat-icon>
      </button>
      <button  (click)="onTest(endpoint)" mat-icon-button >
        <mat-icon>bug_report_outline</mat-icon>
      </button>
    </div>
  </div>
  <div class="add-new-container">
    <button mat-fab color="primary" (click)="onEdit(null)">
   + Add new
    </button>
  </div>
</div>

